import CustomRouterLink from './CustomRouterLink'

export { CustomRouterLink }
export default CustomRouterLink
